import tenantConstants from '@constants';
import React from 'react';
import { Group } from '../../common';
import PostListingSkeleton from './post-listing-from-skeleton';
import { CardListing } from './styled';

/**
 * JSONForm `layout` render: one skeleton card per dynamic section.
 *
 * When the tenant opts into `FORM.HIDE_SECTION_HEADERS` (Bayut KSA — new design
 * has no section icon/title grouping), all fields render in a single continuous
 * flow without the per-section icon + title cards.
 */
export default function PostListingFormSectionsLayout({ formik: form, getFieldsSections, getField, t }) {
  const sections = (getFieldsSections() || []).filter(
    (section) => Array.isArray(section?.fields) && section.fields.length > 0,
  );

  const hideSectionHeaders = !!tenantConstants?.FORM?.HIDE_SECTION_HEADERS;

  if (hideSectionHeaders) {
    // Bayut KSA has no visible sections: order every field purely by its own
    // order key (display_order / secondary_display_order), flattened across all
    // sections, first → last. Section grouping is ignored for ordering.
    const flatFields = sections
      .flatMap((section) => (Array.isArray(section.fields) ? section.fields : []))
      .map((fieldItem, i) => ({ fieldItem, i }))
      .sort((a, b) => {
        const oa = a.fieldItem?.display_order ?? Number.MAX_SAFE_INTEGER;
        const ob = b.fieldItem?.display_order ?? Number.MAX_SAFE_INTEGER;
        return oa - ob || a.i - b.i;
      })
      .map((x) => x.fieldItem);

    return (
      <CardListing narrowGutter>
        {/* Flex column (not grid) so a wide child like the map can't blow the column out
            via grid min-content. Fields take the full available width; CardListing's 42px
            gutter gives the icon-to-edge / field-to-edge margin. */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32, minWidth: 0 }}>
          {flatFields.map((fieldItem) => {
            const fieldNode = getField(fieldItem, form);
            if (!fieldNode) return null;
            return (
              <div key={fieldItem.key} style={{ minWidth: 0 }}>
                {fieldNode}
              </div>
            );
          })}
        </div>
      </CardListing>
    );
  }

  return sections.map((section) => (
    <PostListingSkeleton
      key={section.slug || section.title}
      icon={section.icon || 'PropertyInformationIcon'}
      title={section.title || t('Additional Information')}
    >
      <Group gap="32px" style={{ maxWidth: 640 }}>
        {(Array.isArray(section.fields) ? section.fields : []).map((fieldItem) => {
          const fieldNode = getField(fieldItem, form);
          if (!fieldNode) return null;
          return <React.Fragment key={fieldItem.key}>{fieldNode}</React.Fragment>;
        })}
      </Group>
    </PostListingSkeleton>
  ));
}
